var React = require('react');

function SendInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.59201 14.2306L6.11378 15.8829C5.78332 16.0481 5.39781 15.8279 5.39781 15.4974V11.8625L15.5314 4.26243L3.41532 10.7061L0.276042 8.55819C-0.16459 8.22772 -0.0544247 7.56688 0.441217 7.40159L20.8183 0.0216812C21.0937 -0.0884752 21.6652 1.22467 21.5 1.5L12.5 16.5C12.5 16.5 12 16.5 11.0152 15.8827L8.59201 14.2306Z","fill":"#FFFEFC"}));
}

SendInline.defaultProps = {"width":"22","height":"17","viewBox":"0 0 22 17","fill":"none"};

module.exports = SendInline;

SendInline.default = SendInline;
